import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { NvIconModule } from 'Src/nvps-libraries/design/nv-icon/nv-icon.module';
import { ContentToolsModule } from '../../shell/content-tools/content-tools.module';
import { GraphModule } from './../graph/graph.module';
import { TileDataService } from './tile-data/tile-data.service';
import { TilesComponent } from './tiles.component';

@NgModule({
  declarations: [TilesComponent],
  imports: [CommonModule, GraphModule, ContentToolsModule, NvIconModule, MatCardModule],
  providers: [TileDataService],
})
export class TilesModule {}
